module.exports = __webpack_public_path__ + "img/APY60.098ed6f0.jpg";